import { SelectOption } from '../../../../services/select/interfaces/SelectOption';
import { IpoPricedOption } from '../../../../enums/IpoPricedOption';

export const dealInfoIpoPricedOptions: SelectOption[] = [
  { title: 'Below Range', value: IpoPricedOption.BelowRange },
  { title: 'Within Range', value: IpoPricedOption.WithinRange },
  { title: 'Above Range', value: IpoPricedOption.AboveRange },
  { title: 'All', value: IpoPricedOption.All },
];
